<table>
  <thead>
    <tr>
      <th class="subtable string">{{'mantenimientoPaises.table.tabs.listaProvincias.table.nombre' | translate}}</th>
      <th class="subtable action">
        <i class="fas fa-plus" *ngIf="role === 'Administrador'" (click)="new=true;provinciasEditable=''" title="{{'mantenimientoPaises.provincias.tituloNew' | translate}}"></i>
      </th>
    </tr>
  </thead>
  <tbody>
    <app-new-edit-provincias class="component-in-row" *ngIf="new" [editable]="true" [id]="id" (close)="new=$event"
      (refresh)="toRefresh($event)" (editableChanged)="editableChanged($event)"
      (pushMessage)="pushMessage.emit($event)">
    </app-new-edit-provincias>
    <app-new-edit-provincias class="component-in-row" *ngFor="let provincia of provinciasList" [provincia]="provincia"
      [editable]="provincia === provinciasEditable" (editableChanged)="editableChanged($event)"
      (refresh)="toRefresh($event)" (pushMessage)="pushMessage.emit($event)">
    </app-new-edit-provincias>
  </tbody>
  <tfoot *ngIf="!provinciasList || provinciasList.length < 1">
    <tr>
      <td colspan="6">
        {{ 'global.noContent' | translate }}
      </td>
    </tr>
  </tfoot>
</table>
<app-paginator *ngIf="provinciasList && provinciasList.length > 0" [itemsPerPage]="itemsPerPage"
  [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages" [hiddeItems]="true"
  (pageChange)="pageChange($event)"></app-paginator>
